<div class="modal-header">
    <h5 class="modal-title">Relocate Questions</h5>
    <button type="button" class="btn-close" (click)="onCross()"></button>
  </div>
  
  <div class="modal-body" style="max-height:70vh; overflow:auto;">
    <div *ngIf="!MajorTopics || !MajorTopics.length" style="color: red;">
        No data to display!
      </div>

      
      <ul>
        <ng-container *ngFor="let node of MajorTopics">
          <ng-container *ngTemplateOutlet="treeNodeTpl; context: { $implicit: node }"></ng-container>
        </ng-container>
      </ul>
      
      <ng-template #treeNodeTpl let-node>
        <li>
          <!-- Expand/Collapse FontAwesome Chevron -->
          <span
            *ngIf="node.Data && node.Data.length"
            (click)="toggleExpand(node)"
            style="cursor:pointer;user-select:none;margin-right:3px;"
          >
            <i
              class="fa"
              [ngClass]="node.expanded ? 'fa-angle-down' : 'fa-angle-right'"
              style="font-size: 15px;"
            ></i>
          </span>
          <span *ngIf="!node.Data || !node.Data.length" style="display:inline-block;width:16px;"></span>
          <span style="color:#e64097;font-weight:500;">{{ node.ID }} : {{ node.Name }}</span>
          <input
            *ngIf="isLeaf(node)"
            type="checkbox"
            [checked]="node.checked"
            [disabled]="!!selectedNode && selectedNode !== node"
            (change)="onCheckboxChange(node, getChecked($event))"
            style="margin-left:5px;"
          />
          <ul *ngIf="node.Data && node.Data.length && node.expanded">
            <ng-container *ngFor="let child of node.Data">
              <ng-container *ngTemplateOutlet="treeNodeTpl; context: { $implicit: child }"></ng-container>
            </ng-container>
          </ul>
        </li>
      </ng-template>
      
      
  </div>
  
  <div class="modal-footer">
    <button class="bl-btn btn btn-sm px-3" (click)="onSave()" [disabled]="!selectedNode">Save</button>
    <button class="btn btn-sm bg-light border px-3" (click)="onCross()">Cancel</button>
  </div>
  
  <!-- Recursive Template -->
  <ng-template #treeNodeTpl let-node>
    <li *ngIf="node">
      <span style="color:#e64097;font-weight:500;">{{ node.ID }} : {{ node.Name }}</span>
      <ul *ngIf="node.Data && node.Data.length">
        <ng-container *ngFor="let child of node.Data">
          <ng-template [ngTemplateOutlet]="treeNodeTpl" [ngTemplateOutletContext]="{ node: child }"></ng-template>
        </ng-container>
      </ul>
      <input
        *ngIf="isLeaf(node)"
        type="checkbox"
        [checked]="node.checked"
        [disabled]="!!selectedNode && selectedNode !== node"
        (change)="onCheckboxChange(node, getChecked($event))"
        style="margin-left:5px;"
      />
    </li>
  </ng-template>
  
  